export default "__VITE_ASSET__BL46jwO2__"